import * as actions from './getContactsActions';

const getContactsReducers = {
  [actions.USER_GET_CONTACTS_SUCCESS_RECEIVED]: (state, { payload }) => {
    state.contacts = payload;
    return state;
  },
};

export default getContactsReducers;
